import type { FaireProductEntity } from "../../entity_types/product";

export const p_y6jpp679mv: FaireProductEntity = {
  token: "p_y6jpp679mv",
  type: "product",
  name: "Sun Fun | Mineral Sun Lotion | Reef Safe",
  brandToken: "b_7lde9s8e6u",
  brandName: "New Day Organics LLC",
  imageUrl: "https://cdn.faire.com/fastly/0915c7ac2388dea83c53a461199c427d7ffc9b66cf81e96febf544adb8636ff8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8cc4e90b7d56ce5af2c7ecb2c5ed8c1dbd96984d330d8a728c7bae1f271fabd.jpeg",
    "https://cdn.faire.com/fastly/898e0d4a4e1fcd922e5cbe7644a907b91cf8080cc02efeda4f6ad0144bf059d6.jpeg"
  ],
  priceDollars: 19.95,
  description: "Sun Fun | Mineral Sun Lotion | Reef Safe | Protect | Zinc Oxide\nSun Fun ™️ is an organic mineral-based, reef-safe/ocean-safe sun-lotion you can feel GOOD about wearing!\n\nIt is coconut oil-free, goes on smooth and rubs right in. This sunlotion has an estimated SPF of 30* based on the zinc oxide content.\n\nSun-Fun is;\n- Made with organic and natural ingredients\n- 100% plant & mineral based\n- Reef-safe\n- Cruelty-free\n- Biodegradable\n- Naturally water-resistant\n- Non-comedogenic (won’t clog pores so it can be used as a facial sunscreen too)\n\nOur travel-friendly, 2 oz screw top tin is easy to open transport and store. I keep one in my car, in my beach bag and my backpack.\n\nEvery ingredient has a purpose:\n--Non-nano, uncoated Zinc oxide provides broad-spectrum protection from both UV-A and UV-B forms of ultraviolet radiation.\n--Organic High Oleic Sunflower OIl -- contributes to the smoothness of the sunscreen and provides skin-conditioning properties",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:04.587Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
